import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { shouldShowField, validateField } from '../../../../../components/InputField/helper';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';

const FundFamilyOffices = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    editMode
}) => {
    const { showError } = useContext(DialogContext);

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Funds and Family Offices</h2>
                
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["distributeFunds"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('distributeFunds', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["institutionTypes"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('institutionTypes', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["institutionTypesOther"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('institutionTypesOther', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["requiresFundLicense"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('requiresFundLicense', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasFundLicense"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasFundLicense', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["licenseHolderDetails"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('licenseHolderDetails', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["subsidiesOrSubventions"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('subsidiesOrSubventions', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["assets"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('assets', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.FundFamilyOffices}
                        hideSubmitButton={hideButtons}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.FundFamilyOffices}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default FundFamilyOffices;
